module.exports = __webpack_public_path__ + "static/media/profile-empty.ac4d1159.png";